webpackJsonp([99547440283840],{

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactAccessibleAccordion = __webpack_require__(38);
	
	var _mentor = __webpack_require__(688);
	
	var _mentor2 = _interopRequireDefault(_mentor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Mentor = function (_React$Component) {
	    _inherits(Mentor, _React$Component);
	
	    function Mentor() {
	        _classCallCheck(this, Mentor);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Mentor.prototype.handleSubmit = function handleSubmit(event) {
	        alert("Form submitted. Thank you for your interest in DeltaHacks!");
	        // setTimeout(document.getElementById("mentor-signup-form").reset(), 5000);
	    };
	
	    Mentor.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Workshops - DeltaHacks V'
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: 'Sign up to be a mentor here!' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'main', className: 'gradient' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'description' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'DeltaHacks V :: Workshops'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'table-wrapper' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'SATURDAY : JAN 26, 2019'
	                            ),
	                            _react2.default.createElement(
	                                'table',
	                                null,
	                                _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'TIME'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'PRESENTER & TOPIC'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'VENUE'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '1:00 PM - 2:00 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Natalie Chin - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'A Deep Dive on Blockchain: What\u2019s Behind the Cryptocurrency'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Thode MakerSpace'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '1:00 PM - 2:30 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Darren Tu & Simon Gyorkos - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'Build and Deploy Your First Website'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'ABB B118'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '2:00 PM - 2:30 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Materials Engineering - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'Introduction to their Challenge'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Thode MakerSpace'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '3:00 PM - 4:00 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Innovation Factory - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'Introduction to their Challenge'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Thode MakerSpace'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '3:30 PM - 4:30 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Ocean Cheung - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'Intro to Android Dev'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'ABB B118'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '4:00 PM - 5:00 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'TD - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'Chatbot with Dialogflow'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Thode MakerSpace'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '5:00 PM - 5:30 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'RBC - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'Made from Scratch Software: How to Set-up a Java Spring Boot Server in 5 min'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Thode MakerSpace'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '6:00 PM - 7:00 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Prasann Pandya - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'Deploying Machine Learning Models on the Web'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Thode MakerSpace'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '6:30 PM - 7:30 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Thomas Dykstra - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'NodeJS + Azure'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'ABB B118'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '8:30 PM - 9:30 PM'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Thomas Dykstra - ',
	                                            _react2.default.createElement(
	                                                'i',
	                                                null,
	                                                'Amazon Alexa'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'ABB B118'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAccessibleAccordion.Accordion,
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Descriptions'
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ A Deep Dive on Blockchain: What\u2019s Behind the Cryptocurrency ',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    'by Natalie Chin'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The current Internet world is full of data breaches from corporations we have entrusted to keep our data safe \u2013 like Equifax, Yahoo, Facebook, and more. Blockchain allows us to take back the trust we\u2019ve put in them \u2013 taking it into our own hands. In this workshop, we\u2019re going to talk about what blockchain is, what difference it can make in our lives, setting up a development environment, and live-coding examples of cryptocurrency transactions.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ Build and Deploy Your First Website',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    ' by Darren Tu & Simon Gyorkos'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'During this workshop, participants will learn the structure and syntax of basic HTML and CSS. Participants will receive a skeleton of a portfolio website and will update the HTML to include information about themselves and edit the CSS to style and position elements on their page! Then, they\u2019ll deploy their new website.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ Introduction to Challenge ',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    ' by Materials Engineering'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'We will be introducing our challenge. ',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'code',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '/sponsorchallenges' },
	                                        'Sponsor Challenges'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ Introduction to Challenge ',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    ' by Innovation Factory'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'We will be introducing our challenge. ',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'code',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '/sponsorchallenges' },
	                                        'Sponsor Challenges'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ Introduction to Android Development',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    ' by Ocean Cheung'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Learn how to build android apps for DeltaHacks, or how to polish one up to be used as a portfolio piece.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ Chatbot with Dialogflow',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    ' by TD'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'An introduction to creating chatbots using Dialogflow.  This session provides an overview of creating a couple of simple chatbots using the Dialogflow graphical user interface(no programming required).  We will create a frequently asked questions or knowledge bot, as well as a simple order taking bot.  We will also explore the various integrations options available(Google Assistant, FaceBook Messenger, Telephony), discuss request fulfillment to backend services, and review some of the prebuilt agents that the product Dialogflow offers.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ Use of Algo\u2019s and Machine Learning',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    ' by RBC'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Hosted by Marat Khandros, Director of Development, Global Technology Infrastructure ',
	                                _react2.default.createElement('br', null),
	                                'For our workshop we will show how a heavily used production app started as a simple java/springboot server and grew to encompass many points within GTI.  We will set up this base framework which some of the students might use for their projects.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ Deploying Machine Learning Models on the Web',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    ' by Prasann Pandya'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Learn how to take a trained machine learning model and deploy it on a web server as an API which can then be used on a mobile app or a website. Attendees will also learn how to use some standard computer vision/NLP models already deployed as an API in their hackathon projects.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ NodeJS & Azure',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    ' by Thomas Dykstra'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Be sure to attend this workshop. We will start from the basics. No. Seriously. We are going to start with guiding you on how to download Visual Studio Code and take it from there. The Javascript web development is THE tool you need to get your hack to working! ',
	                                _react2.default.createElement('br', null),
	                                ' ',
	                                _react2.default.createElement('br', null),
	                                'BONUS: we will be guiding each of you so that you can have a final product to take with you at the end of the session! ',
	                                _react2.default.createElement('br', null),
	                                ' ',
	                                _react2.default.createElement('br', null),
	                                'P.S. Node.js and Express is sure to give you the foothold you need to land you an interview for your co-ops or future jobs.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactAccessibleAccordion.AccordionItem,
	                        null,
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemTitle,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '+ Hacking with Amazon Alexa',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    ' by Thomas Dykstra'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactAccessibleAccordion.AccordionItemBody,
	                            null,
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'During this workshop you\u2019ll learn the basics of how to build skills for Amazon Alexa to run on Alexa devices like the Amazon Tap or Echo. It covers setting up Alexa Skills Kit, developing your first skill, deploying your skill to AWS Lambda, and submitting your skill for publication.'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Mentor;
	}(_react2.default.Component);
	
	exports.default = Mentor;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-workshops-js-26ec4f0def0481deabb6.js